module.exports = __webpack_public_path__ + "whitefoot.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitefoot.png
// module id = 889
// module chunks = 0